import { ComponentProps, useMemo } from 'react';
import theme from 'App.theme';
import { TurnaroundEntityButton } from 'components/TurnaroundEntityButton/TurnaroundEntityButton';

type Props = ComponentProps<typeof TurnaroundEntityButton> & {
  set: {
    kitInstanceId: string;
    displayCode: string;
    trays?: Array<{
      trayInstanceId: string;
      name: string;
      trayReference?: number | null;
    }>;
  };
};

export const TurnaroundSet = ({ set, ...props }: Props) => {
  const sortedTrays = useMemo(() => set.trays?.sort((a, b) => a.name.localeCompare(b.name)), [set.trays]);

  return (
    <TurnaroundEntityButton {...props}>
      <span style={{ minWidth: 80, textAlign: 'left' }}>{set.displayCode}</span>

      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          gap: theme.layout.spacing.small,
          overflowX: 'auto',
          // hide the horizontal scrollbar
          msOverflowStyle: 'none' /* IE and Edge */,
          scrollbarWidth: 'none' /* Firefox */,
        }}
      >
        {sortedTrays?.map(tray => (
          <div
            key={tray.trayInstanceId}
            style={{
              display: 'flex',
              border: `1px solid ${theme.colors.tealDark}`,
              height: '22px',
              borderRadius: '11px',
            }}
          >
            <span
              style={{
                background: theme.colors.tealDark,
                color: theme.colors.tealLight,
                fontSize: 12,
                display: 'flex',
                justifyContent: 'center',
                padding: '5px 0',
                height: '22px',
                width: '22px',
                textAlign: 'center',
                lineHeight: 1,
                borderRadius: '11px',
                marginLeft: '-1px',
                marginTop: '-1px',
              }}
            >
              {tray.trayReference || '-'}
            </span>
            <span
              style={{
                padding: `0 ${theme.layout.spacing.small}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                color: theme.colors.tealDark,
                whiteSpace: 'nowrap',
              }}
            >
              {tray.name}
            </span>
          </div>
        ))}
      </div>
    </TurnaroundEntityButton>
  );
};
